import React, { useState } from "react";
import { Button } from "@panda0/panda0-ui";
import { toast } from "sonner";

import { EmailTemplate } from "../types";

// Template Editor Component
function TemplateEditor({
  template,
  onSave,
  onCancel,
}: {
  template: EmailTemplate | null;
  onSave: (template: EmailTemplate) => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState(template?.name || "");
  const [subject, setSubject] = useState(template?.subject || "");
  const [body, setBody] = useState(template?.body || "");

  return (
    <div className="space-y-5 p-4">
      <div>
        <label className="block text-sm font-medium text-neutral-700">
          Template Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="mt-1 block w-full rounded-md border border-neutral-300 py-2 px-3 shadow-sm focus:border-neutral-500 focus:outline-none focus:ring-neutral-500 sm:text-sm"
          placeholder="E.g., Technical Quiz Invitation"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-neutral-700">
          Subject Line
        </label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          className="mt-1 block w-full rounded-md border border-neutral-300 py-2 px-3 shadow-sm focus:border-neutral-500 focus:outline-none focus:ring-neutral-500 sm:text-sm"
          placeholder="E.g., Your Technical Quiz for {jobTitle}"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-neutral-700">
          Template Content
        </label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          rows={12}
          className="mt-1 block w-full rounded-md border border-neutral-300 py-2 px-3 shadow-sm focus:border-neutral-500 focus:outline-none focus:ring-neutral-500 sm:text-sm"
          placeholder="Dear {firstName},

Thank you for your interest in the {jobTitle} position..."
        ></textarea>
        <p className="mt-1 text-xs text-neutral-600">
          Available placeholders: {"{firstName}"}, {"{lastName}"},{" "}
          {"{jobTitle}"}, {"{companyName}"}, {"{pandaQuizLink}"}, {"{deadline}"}
          , {"{recruiterName}"}
        </p>
      </div>

      <div className="flex justify-end gap-2 pt-4">
        <Button variant="secondary" text="Cancel" onClick={onCancel} />
        <Button
          variant="primary"
          text="Save Template"
          onClick={() => {
            if (!name) {
              toast.error("Please provide a template name");
              return;
            }
            if (!subject) {
              toast.error("Please provide a subject line");
              return;
            }
            if (!body) {
              toast.error("Please provide template content");
              return;
            }
            onSave({
              id: template?.id || `template-${Date.now()}`,
              name,
              subject,
              body,
            });
          }}
        />
      </div>
    </div>
  );
}

export default React.memo(TemplateEditor);
